import { FC, useCallback, useState } from 'react';
import { PikProjectsChipsDataService } from 'shared/services/ChipsDataService';
import { IPikProjectsItemViewModel, PikProjectsItemViewModel } from './external/models/PikProjectsItemViewModel';
import { ChipsOption } from 'shared/models/ChipsOption';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { PikProjects } from './PikProjects';
import { IconActionMap16, IconActionTable16 } from '@cian/ui-kit-design-tokens/icons';

const pikProjectsChipsDataService = new PikProjectsChipsDataService([
  new PikProjectsItemViewModel(new ChipsOption('Плитками', undefined, <IconActionTable16 />), 'list'),
  new PikProjectsItemViewModel(new ChipsOption('На карте', undefined, <IconActionMap16 />), 'map'),
]);

export const PikProjectsContainer: FC = () => {
  const { logger } = useApplicationContext();

  const [activePikProjectsItem, setActivePikProjectsItem] = useState<IPikProjectsItemViewModel>(
    pikProjectsChipsDataService.defaultItem,
  );

  const handleChange = useCallback<(value: string[]) => void>(
    value => {
      setActivePikProjectsItem(pikProjectsChipsDataService.getActiveItem(value[0], logger));
    },
    [logger],
  );

  return (
    <PikProjects
      chipsOptions={pikProjectsChipsDataService.chipsOptions}
      activePikProjectsItem={activePikProjectsItem}
      onChange={handleChange}
    />
  );
};
